export default class ModalOpener extends HTMLElement {
    constructor() {
        super();
    
        const button = this.querySelector('button');
    
        if (!button) return;
        button.addEventListener('click', (event) => {
            // Prevent submit buttons (e.g. collection "Choose options") from also posting their form
            // or otherwise triggering default click behavior.
            event.preventDefault();

            const modal = document.querySelector(this.getAttribute('data-modal'));
            const buttonType = this.getAttribute('data-button');
            
            // If button has a type of 'toggle' then add is-active class
            if (modal && buttonType === 'toggle' && !button.classList.contains('is-active')) {
                button.classList.add('is-active');
                modal.show(button);
            } else if (modal && buttonType === 'toggle' && button.classList.contains('is-active')) {
                modal.hide();
            } else if (modal) {
                modal.show(button);
            }
        });
    }
}

customElements.define('modal-opener', ModalOpener);
